module.exports = __webpack_public_path__ + "static/media/0401renaming.5086fbc4.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0401renaming.mov
// module id = 395
// module chunks = 0